import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@components/shared/elements'

import './Dropdown.scss'

import $ from 'jquery'

class Dropdown extends React.Component {

  constructor(props) {
    super(props)

    this.el = React.createRef()
  }

  componentDidMount() {
    $(this.el.current).foundation()
  }

  render() {

    return (

      <div className='dropdown' ref={this.el}>

        <div data-toggle={this.props.id}>
          {this.props.title}
          <Icon icon='sort-down' />
        </div>

        <div className='dropdown-pane' id={this.props.id} data-dropdown data-position={this.props.position} data-alignment={this.props.alignment} data-auto-focus='true'>
          {this.props.children}
        </div>

      </div>

    )
  }
}

Dropdown.defaultProps = {
  position: 'bottom',
  alignment: 'right',
}

Dropdown.propTypes = {
  id: PropTypes.string.isRequired,
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/shared/elements/Dropdown/Dropdown.js